"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

var Divider = function Divider() {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-divider",
    role: "separator"
  });
};
var _default = exports.default = Divider;